import { Progress } from '@backstage/core-components';
import {
  useApi,
  configApiRef,
  fetchApiRef,
} from '@backstage/core-plugin-api';
import { Alert } from '@material-ui/lab';
import React, { useState, useEffect } from 'react';
import UserWidget from './userWidget';
import { useUser, GroupMemberships } from '../../../context/userContext';

type UserContext = {
  kind: string;
  metadata: UserMetaData;
  relations: UserRelation[];
  spec: SpecData;
};

type SpecData = {
  type: string;
};

type UserMetaData = {
  name: string;
  namespace: string;
};

type UserRelation = {
  target: RelationTarget[];
  targetRef: string;
  type: string;
};

type RelationTarget = {
  kind: string;
  name: string;
  namespace: string;
};

export function squadNameFormat(squadName: string) {
  if (squadName.includes('squad')) return squadName;
  return `${squadName}-squad`;
}

const UserFetchComponent = () => {
  const config = useApi(configApiRef);
  const baseURLforWidget = config.getOptionalString('backend.baseUrl');
  const { fetch: backstageFetch } = useApi(fetchApiRef);

  const [groupMemberships, setGroupMemberships] = useState<GroupMemberships[]>(
    [],
  );
  const [loadingComponents, setLoadingComponents] = useState(true);
  const [loadingUser, setLoadingUser] = useState(true);
  const [catalogError, setCatalogError] = useState(null);
  const [catalogComponents, setCatalogComponents] = useState<UserContext[]>([]);
  const { getUser } = useUser();

  useEffect(() => {
    (async () => {
      const userData = await getUser();
      setGroupMemberships(userData.groupMemberships);
      setLoadingUser(false);
    })();
  }, [getUser]);

  useEffect(() => {
    (async () => {
      const resJson = await Promise.all(
        groupMemberships.map(async obj => {
          const squadName = squadNameFormat(obj.squad);
          return await backstageFetch(
            `${baseURLforWidget}/api/catalog/entities?filter=kind=Component,kind=API,kind=System,relations.ownedBy=group%3Adefault%2F${squadName}&fields=kind,metadata.name,metadata.namespace,spec.type,relations`,
          ).then(
            res => res.json(),
            err => setCatalogError(err),
          );
        }),
      );
      let returnArray: UserContext[] = [];
      resJson.map(item => {
        returnArray = [...returnArray, ...item];
      });
      setCatalogComponents(returnArray);
      setLoadingComponents(false);
    })();
  }, [groupMemberships, baseURLforWidget, backstageFetch]);

  if (loadingUser || loadingComponents) {
    return <Progress />;
  } else if (catalogError) {
    return <Alert severity="error">{catalogError.message}</Alert>;
  }

  return (
    <UserWidget data={catalogComponents} groupMemberships={groupMemberships} />
  );
};

export default UserFetchComponent;
